import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../../Typography';

export interface LeaderBoardLabelProps extends ComponentProps<'div'> {
  rankLabel?: string;
  teamLabel?: string;
  averageLabel?: string;
  gameweekPointsLabel?: string;
  totalLabel?: string;
  showAverage?: boolean;
  showGameweekPoints?: boolean;
}

export const LeaderBoardLabel = ({
  className,
  rankLabel = 'RANK',
  teamLabel = 'TEAM',
  averageLabel = 'AVG.',
  gameweekPointsLabel = 'GW PTS',
  totalLabel = 'TOTAL',
  showAverage = true,
  showGameweekPoints = true,
  ...otherProps
}: LeaderBoardLabelProps) => {
  return (
    <div
      className={twMerge(
        [
          'flex items-center border-b border-solid border-[#eae9fd] bg-[white] px-[--padding-xs]',
          'gap-[--padding-xs] py-[--padding-sm]',
          'md:gap-[--padding-md] md:py-[--padding-md]',
        ],
        className
      )}
      {...otherProps}
    >
      <div className="flex min-w-0 flex-1 items-center gap-[--padding-xs]">
        <Typography
          as="span"
          variant="paragraph000"
          className="w-[50px] text-center text-[#757777] md:w-[72px] md:text-12 md:leading-16"
        >
          {rankLabel}
        </Typography>
        <Typography
          as="span"
          variant="paragraph000"
          className="flex-1 text-[#757777] md:text-12 md:leading-16"
        >
          {teamLabel}
        </Typography>
      </div>
      <div className="flex shrink-0 items-center gap-[--padding-xs] text-center">
        {showAverage && (
          <Typography
            as="span"
            variant="paragraph000"
            className="w-[46px] text-[#757777] md:w-[72px] md:text-12 md:leading-16"
          >
            {averageLabel}
          </Typography>
        )}
        {showGameweekPoints && (
          <Typography
            as="span"
            variant="paragraph000"
            className="w-[46px] text-[#757777] md:w-[72px] md:text-12 leading-16"
          >
            {gameweekPointsLabel}
          </Typography>
        )}
        <Typography
          as="span"
          variant="paragraph000"
          className="w-[56px] text-[#757777] md:w-[72px] md:text-12 md:leading-16"
        >
          {totalLabel}
        </Typography>
      </div>
    </div>
  );
};
